import React, {useCallback, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp, faChalkboardUser, faCirclePlus} from "@fortawesome/free-solid-svg-icons";
import PositionTraining from "./PositionTraining";
import {trainingDefault} from "../../../../defaults/Items";

const PositionTrainingsCard = ({state, trainingsList}) => {
  const currentItem = state.currentItem;
  const requiredTrainings = currentItem?.requiredTrainings || [];
  const setCurrentItem = state.setCurrentItem;
  const setItemChanged = state.setItemChanged;
  const itemChanged = state.itemChanged;
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  const filteredTrainingsList = trainingsList.filter(
    training => !requiredTrainings.some(reqTrn => reqTrn.id === training.id)
  );

  const addTraining = () => {
    const existingIds = requiredTrainings.map(training => training.id);
    let newId = -1;
    while (existingIds.includes(newId)) newId--;
    const newTraining = {...trainingDefault, id: newId, name: "---Wybierz---"};
    setCurrentItem({...currentItem, requiredTrainings: [...requiredTrainings, newTraining]});
    setItemChanged(!itemChanged);
  };

  const removeTraining = useCallback((trainingId) => {
    setCurrentItem({
      ...currentItem,
      requiredTrainings: requiredTrainings.filter(item => item.id !== trainingId)
    });
    setItemChanged(!itemChanged);
  }, [requiredTrainings, currentItem, setCurrentItem, setItemChanged, itemChanged]);

  return (
    <section className="position-requirement-card">
      <button
        type="button"
        className="position-requirement-card-header"
        onClick={() => setIsAccordionOpen(value => !value)}
      >
        <span className="position-requirement-card-title">
          <FontAwesomeIcon icon={faChalkboardUser}/>
          <span>Wymagane szkolenia</span>
          <span className="position-requirement-count">{requiredTrainings.length}</span>
        </span>
        <FontAwesomeIcon icon={isAccordionOpen ? faChevronUp : faChevronDown}/>
      </button>

      {isAccordionOpen && (
        <div className="position-requirement-card-body" id="requiredTrainings">
          <div className="position-requirement-card-toolbar">
            <span>Pracownik musi mieć wszystkie wskazane szkolenia, aby spełnić wymagania stanowiska.</span>
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={addTraining}>
              <FontAwesomeIcon icon={faCirclePlus}/> Dodaj
            </button>
          </div>

          <div className="position-requirement-list">
            {requiredTrainings.length > 0 ? requiredTrainings.map((training, index) => (
              <PositionTraining
                key={training.id ?? index}
                index={index}
                state={state}
                trainingsList={filteredTrainingsList}
                onRemove={() => removeTraining(training.id)}
              />
            )) : (
              <div className="position-requirement-empty">Brak wymaganych szkoleń</div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default PositionTrainingsCard;
